/**
 * @generated SignedSource<<b6d00156e560f5dffe9ad546ad4b9654>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoFeedbackStatus = "FEEDBACK_COMPLETED" | "FEEDBACK_DISMISSED" | "FEEDBACK_NEEDED";
export type TodoEditFeedbackPopover_updateFeedbackStatusMutation$variables = {
  employeeId?: string | null;
  newFeedbackStatus: TodoFeedbackStatus;
  todoId: string;
};
export type TodoEditFeedbackPopover_updateFeedbackStatusMutation$data = {
  readonly todo: {
    readonly updateFeedbackStatus: {
      readonly allTodoFeedbacks: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"TodoEditFeedbackPopoverFeedbackHistory_todoFeedback">;
      }>;
      readonly feedbackStatus: TodoFeedbackStatus | null;
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"TodoEditTimeline_todo">;
    };
  } | null;
};
export type TodoEditFeedbackPopover_updateFeedbackStatusMutation = {
  response: TodoEditFeedbackPopover_updateFeedbackStatusMutation$data;
  variables: TodoEditFeedbackPopover_updateFeedbackStatusMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "employeeId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "newFeedbackStatus"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "todoId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "employeeId",
    "variableName": "employeeId"
  },
  {
    "kind": "Variable",
    "name": "todoId",
    "variableName": "todoId"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "newFeedbackStatus",
    "variableName": "newFeedbackStatus"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "feedbackStatus",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "body",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v10 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isActor"
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    {
      "kind": "TypeDiscriminator",
      "abstractKey": "__isPublicAndInternalImage"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "publicImageUrl",
          "storageKey": null
        }
      ],
      "type": "PublicImage",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v5/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "thumbhash",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ImageSize",
          "kind": "LinkedField",
          "name": "sizes",
          "plural": true,
          "selections": [
            (v5/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "urlExpiresAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "height",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "width",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Image",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "workStatus",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "OrgDescription",
  "kind": "LinkedField",
  "name": "orgDescription",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "orgIconUri",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v16 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "StorecastScreen",
      "kind": "LinkedField",
      "name": "screen",
      "plural": false,
      "selections": [
        (v11/*: any*/),
        (v5/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "ScreenActor",
  "abstractKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "Employee",
  "kind": "LinkedField",
  "name": "employee",
  "plural": false,
  "selections": [
    (v11/*: any*/),
    (v12/*: any*/),
    (v13/*: any*/),
    (v5/*: any*/),
    (v9/*: any*/)
  ],
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "identifyingName",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    (v5/*: any*/)
  ],
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "createdByActor",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    (v10/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "StoreUser",
          "kind": "LinkedField",
          "name": "storeUser",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Employee",
              "kind": "LinkedField",
              "name": "employee",
              "plural": false,
              "selections": [
                (v11/*: any*/),
                (v12/*: any*/),
                (v13/*: any*/),
                (v5/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "user",
              "plural": false,
              "selections": [
                (v11/*: any*/),
                (v5/*: any*/),
                (v14/*: any*/),
                (v15/*: any*/)
              ],
              "storageKey": null
            },
            (v5/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "UserActor",
      "abstractKey": null
    },
    (v16/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v17/*: any*/),
        (v18/*: any*/),
        (v19/*: any*/)
      ],
      "type": "GroupActor",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v17/*: any*/),
        (v18/*: any*/)
      ],
      "type": "ConnectActor",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v21 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "style",
        "value": "DEFAULT"
      }
    ],
    "kind": "ScalarField",
    "name": "storeFormattedDate",
    "storageKey": "storeFormattedDate(style:\"DEFAULT\")"
  }
],
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "StoreZonedDate",
  "kind": "LinkedField",
  "name": "createdAtDate",
  "plural": false,
  "selections": (v21/*: any*/),
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "TodoContact",
  "kind": "LinkedField",
  "name": "contact",
  "plural": false,
  "selections": [
    (v14/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phoneNumber",
      "storageKey": null
    },
    (v11/*: any*/)
  ],
  "storageKey": null
},
v24 = [
  {
    "kind": "Literal",
    "name": "last",
    "value": 100
  }
],
v25 = [
  (v5/*: any*/),
  (v11/*: any*/)
],
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v27 = [
  (v5/*: any*/),
  (v8/*: any*/),
  (v26/*: any*/)
],
v28 = [
  (v5/*: any*/),
  (v11/*: any*/),
  (v26/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "icon",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TodoEditFeedbackPopover_updateFeedbackStatusMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "TodoMutation",
        "kind": "LinkedField",
        "name": "todo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "Todo",
            "kind": "LinkedField",
            "name": "updateFeedbackStatus",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TodoFeedback",
                "kind": "LinkedField",
                "name": "allTodoFeedbacks",
                "plural": true,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "TodoEditFeedbackPopoverFeedbackHistory_todoFeedback"
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "Defer",
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "TodoEditTimeline_todo"
                  }
                ]
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "TodoEditFeedbackPopover_updateFeedbackStatusMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "TodoMutation",
        "kind": "LinkedField",
        "name": "todo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "Todo",
            "kind": "LinkedField",
            "name": "updateFeedbackStatus",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TodoFeedback",
                "kind": "LinkedField",
                "name": "allTodoFeedbacks",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v20/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/)
                ],
                "storageKey": null
              },
              {
                "if": null,
                "kind": "Defer",
                "label": "TodoEditFeedbackPopover_updateFeedbackStatusMutation$defer$TodoEditTimeline_todo",
                "selections": [
                  (v20/*: any*/),
                  (v22/*: any*/),
                  {
                    "alias": null,
                    "args": (v24/*: any*/),
                    "concreteType": "TodoTimelineConnection",
                    "kind": "LinkedField",
                    "name": "timeline",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TodoTimelineEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              {
                                "kind": "TypeDiscriminator",
                                "abstractKey": "__isTodoTimelineItem"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "canDelete",
                                    "storageKey": null
                                  },
                                  (v5/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "comment",
                                    "storageKey": null
                                  },
                                  (v20/*: any*/),
                                  (v22/*: any*/)
                                ],
                                "type": "TodoComment",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "events",
                                    "plural": true,
                                    "selections": [
                                      (v9/*: any*/),
                                      {
                                        "kind": "TypeDiscriminator",
                                        "abstractKey": "__isTodoTimelineUpdateEvent"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Employee",
                                            "kind": "LinkedField",
                                            "name": "addedAssignedEmployees",
                                            "plural": true,
                                            "selections": (v25/*: any*/),
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Employee",
                                            "kind": "LinkedField",
                                            "name": "removedAssignedEmployees",
                                            "plural": true,
                                            "selections": (v25/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "TodoTimelineUpdateEventAssignedEmployees",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "newTitle",
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "TodoTimelineUpdateEventTitle",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "newBody",
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "TodoTimelineUpdateEventBody",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "newStatus",
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "TodoTimelineUpdateEventStatus",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "newPriority",
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "TodoTimelineUpdateEventPriority",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "TodoCategory",
                                            "kind": "LinkedField",
                                            "name": "newCategory",
                                            "plural": false,
                                            "selections": [
                                              (v8/*: any*/),
                                              (v5/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "TodoTimelineUpdateEventCategory",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "StoreZonedDate",
                                            "kind": "LinkedField",
                                            "name": "newExpireAt",
                                            "plural": false,
                                            "selections": (v21/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "TodoTimelineUpdateEventExpireAt",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "TodoCategoryTag",
                                            "kind": "LinkedField",
                                            "name": "addedTodoTags",
                                            "plural": true,
                                            "selections": (v27/*: any*/),
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "TodoCategoryTag",
                                            "kind": "LinkedField",
                                            "name": "removedTodoTags",
                                            "plural": true,
                                            "selections": (v27/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "TodoTimelineUpdateEventTags",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Team",
                                            "kind": "LinkedField",
                                            "name": "addedAssignedTeams",
                                            "plural": true,
                                            "selections": (v28/*: any*/),
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Team",
                                            "kind": "LinkedField",
                                            "name": "removedAssignedTeams",
                                            "plural": true,
                                            "selections": (v28/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "TodoTimelineUpdateEventAssignedTeams",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "EmployeeRole",
                                            "kind": "LinkedField",
                                            "name": "addedAssignedRoles",
                                            "plural": true,
                                            "selections": (v25/*: any*/),
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "EmployeeRole",
                                            "kind": "LinkedField",
                                            "name": "removedAssignedRoles",
                                            "plural": true,
                                            "selections": (v25/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "TodoTimelineUpdateEventAssignedRoles",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v22/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "createdByActor",
                                    "plural": false,
                                    "selections": [
                                      (v9/*: any*/),
                                      (v10/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "StoreUser",
                                            "kind": "LinkedField",
                                            "name": "storeUser",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Employee",
                                                "kind": "LinkedField",
                                                "name": "employee",
                                                "plural": false,
                                                "selections": [
                                                  (v11/*: any*/),
                                                  (v5/*: any*/),
                                                  (v12/*: any*/),
                                                  (v13/*: any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "User",
                                                "kind": "LinkedField",
                                                "name": "user",
                                                "plural": false,
                                                "selections": [
                                                  (v11/*: any*/),
                                                  (v14/*: any*/),
                                                  (v5/*: any*/),
                                                  (v15/*: any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              (v5/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "UserActor",
                                        "abstractKey": null
                                      },
                                      (v16/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Employee",
                                            "kind": "LinkedField",
                                            "name": "employee",
                                            "plural": false,
                                            "selections": [
                                              (v11/*: any*/),
                                              (v5/*: any*/),
                                              (v9/*: any*/),
                                              (v12/*: any*/),
                                              (v13/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v18/*: any*/),
                                          (v19/*: any*/)
                                        ],
                                        "type": "GroupActor",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v18/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Employee",
                                            "kind": "LinkedField",
                                            "name": "employee",
                                            "plural": false,
                                            "selections": [
                                              (v11/*: any*/),
                                              (v5/*: any*/),
                                              (v12/*: any*/),
                                              (v13/*: any*/),
                                              (v9/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "ConnectActor",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "TodoTimelineUpdate",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v8/*: any*/),
                                  (v7/*: any*/),
                                  (v20/*: any*/),
                                  (v22/*: any*/),
                                  (v23/*: any*/),
                                  (v5/*: any*/)
                                ],
                                "type": "TodoFeedback",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "cursor",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasPreviousPage",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "startCursor",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "ClientExtension",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__id",
                            "storageKey": null
                          }
                        ]
                      }
                    ],
                    "storageKey": "timeline(last:100)"
                  },
                  {
                    "alias": null,
                    "args": (v24/*: any*/),
                    "filters": null,
                    "handle": "connection",
                    "key": "TodoEditTimeline__timeline",
                    "kind": "LinkedHandle",
                    "name": "timeline"
                  },
                  (v5/*: any*/)
                ]
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2f0e9e38f4dbe85588a05ebef00e3e79",
    "id": null,
    "metadata": {},
    "name": "TodoEditFeedbackPopover_updateFeedbackStatusMutation",
    "operationKind": "mutation",
    "text": "mutation TodoEditFeedbackPopover_updateFeedbackStatusMutation(\n  $todoId: ID!\n  $employeeId: ID\n  $newFeedbackStatus: TodoFeedbackStatus!\n) {\n  todo(todoId: $todoId, employeeId: $employeeId) {\n    updateFeedbackStatus(newFeedbackStatus: $newFeedbackStatus) {\n      id\n      feedbackStatus\n      allTodoFeedbacks {\n        ...TodoEditFeedbackPopoverFeedbackHistory_todoFeedback\n        id\n      }\n      ...TodoEditTimeline_todo @defer(label: \"TodoEditFeedbackPopover_updateFeedbackStatusMutation$defer$TodoEditTimeline_todo\")\n    }\n  }\n}\n\nfragment AHTeamIcon on Team {\n  icon\n}\n\nfragment Avatar_actor on Actor {\n  __isActor: __typename\n  ... on UserActor {\n    __typename\n    storeUser {\n      employee {\n        name\n        ...Avatar_employee\n        id\n      }\n      user {\n        name\n        ...Avatar_user\n        id\n      }\n      id\n    }\n  }\n  ... on ScreenActor {\n    __typename\n    screen {\n      name\n      id\n    }\n  }\n  ... on GroupActor {\n    __typename\n    ...Avatar_groupActor\n  }\n  ... on ConnectActor {\n    __typename\n    ...Avatar_connectActor\n  }\n}\n\nfragment Avatar_connectActor on ConnectActor {\n  employee {\n    name\n    ...Avatar_employee\n    id\n  }\n}\n\nfragment Avatar_employee on Employee {\n  image {\n    __typename\n    ...ImagePublicOrPrivate_image\n    ... on Image {\n      id\n    }\n  }\n  workStatus\n  name\n}\n\nfragment Avatar_groupActor on GroupActor {\n  employee {\n    name\n    ...Avatar_employee\n    id\n  }\n}\n\nfragment Avatar_user on User {\n  name\n}\n\nfragment ImagePublicOrPrivate_image on PublicAndInternalImage {\n  __isPublicAndInternalImage: __typename\n  ... on PublicImage {\n    ...ImagePublic_image\n    __typename\n  }\n  ... on Image {\n    id\n    ...Image_image\n    __typename\n  }\n}\n\nfragment ImagePublic_image on PublicImage {\n  publicImageUrl\n}\n\nfragment Image_image on Image {\n  id\n  thumbhash\n  sizes {\n    id\n    url\n    urlExpiresAt\n    height\n    width\n  }\n}\n\nfragment SignedActorBadge_actor on Actor {\n  __isActor: __typename\n  ... on UserActor {\n    storeUser {\n      user {\n        orgDescription {\n          orgIconUri\n        }\n        id\n      }\n      id\n    }\n    __typename\n  }\n  ... on ConnectActor {\n    employee {\n      __typename\n      id\n    }\n    __typename\n  }\n  ... on GroupActor {\n    __typename\n    employee {\n      __typename\n      id\n    }\n    user {\n      __typename\n      id\n    }\n  }\n}\n\nfragment SignedActorCompactBadge_actor on Actor {\n  __isActor: __typename\n  ... on UserActor {\n    storeUser {\n      user {\n        orgDescription {\n          orgIconUri\n        }\n        id\n      }\n      id\n    }\n    __typename\n  }\n  ... on GroupActor {\n    __typename\n    employee {\n      __typename\n      id\n    }\n    user {\n      __typename\n      id\n    }\n  }\n  ... on ScreenActor {\n    __typename\n  }\n  ... on ConnectActor {\n    __typename\n  }\n}\n\nfragment SignedActorCompact_actor on Actor {\n  __isActor: __typename\n  ...SignedActorText_actor\n  ...SignedActorCompactBadge_actor\n}\n\nfragment SignedActorText_actor on Actor {\n  __isActor: __typename\n  ... on UserActor {\n    __typename\n    storeUser {\n      employee {\n        name\n        id\n      }\n      user {\n        name\n        email\n        id\n      }\n      id\n    }\n  }\n  ... on ScreenActor {\n    __typename\n    screen {\n      name\n      id\n    }\n  }\n  ... on GroupActor {\n    __typename\n    employee {\n      name\n      id\n    }\n    identifyingName\n  }\n  ... on ConnectActor {\n    __typename\n    identifyingName\n    employee {\n      name\n      id\n    }\n  }\n}\n\nfragment SignedActor_actor on Actor {\n  __isActor: __typename\n  ...Avatar_actor\n  ...SignedActorText_actor\n  ...SignedActorBadge_actor\n}\n\nfragment StoreFormattedDate on StoreZonedDate {\n  storeFormattedDate(style: DEFAULT)\n}\n\nfragment TodoEditFeedbackPopoverFeedbackHistory_todoFeedback on TodoFeedback {\n  id\n  body\n  ...TodoTimelineFeedback_feedback\n}\n\nfragment TodoEditTimeline_todo on Todo {\n  ...TodoTimelineUpdateEventCreated_todo\n  timeline(last: 100) {\n    edges {\n      node {\n        __typename\n        ... on TodoComment {\n          canDelete\n          id\n        }\n        ...TodoTimeline_item\n        ... on TodoFeedback {\n          id\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      hasPreviousPage\n      startCursor\n    }\n  }\n  id\n}\n\nfragment TodoTimelineComment_todoComment on TodoComment {\n  comment\n  id\n  createdByActor {\n    __typename\n    ...SignedActor_actor\n  }\n  createdAtDate {\n    ...StoreFormattedDate\n  }\n}\n\nfragment TodoTimelineFeedback_feedback on TodoFeedback {\n  title\n  body\n  createdByActor {\n    __typename\n    ...SignedActor_actor\n  }\n  createdAtDate {\n    ...StoreFormattedDate\n  }\n  contact {\n    email\n    phoneNumber\n    name\n  }\n}\n\nfragment TodoTimelineUpdateEventBody_event on TodoTimelineUpdateEvent {\n  __isTodoTimelineUpdateEvent: __typename\n  __typename\n  ... on TodoTimelineUpdateEventAssignedEmployees {\n    addedAssignedEmployees {\n      id\n      ...TodoTimelineUpdateEventEmployee_employee\n    }\n    removedAssignedEmployees {\n      id\n      ...TodoTimelineUpdateEventEmployee_employee\n    }\n    __typename\n  }\n  ... on TodoTimelineUpdateEventTitle {\n    newTitle\n    __typename\n  }\n  ... on TodoTimelineUpdateEventBody {\n    newBody\n    __typename\n  }\n  ... on TodoTimelineUpdateEventStatus {\n    newStatus\n    __typename\n  }\n  ... on TodoTimelineUpdateEventPriority {\n    newPriority\n    __typename\n  }\n  ... on TodoTimelineUpdateEventCategory {\n    newCategory {\n      title\n      id\n    }\n    __typename\n  }\n  ... on TodoTimelineUpdateEventExpireAt {\n    __typename\n    newExpireAt {\n      ...StoreFormattedDate\n    }\n  }\n  ... on TodoTimelineUpdateEventTags {\n    addedTodoTags {\n      id\n      ...TodoTimelineUpdateEventTag_tag\n    }\n    removedTodoTags {\n      id\n      ...TodoTimelineUpdateEventTag_tag\n    }\n    __typename\n  }\n  ... on TodoTimelineUpdateEventAssignedTeams {\n    addedAssignedTeams {\n      id\n      ...TodoTimelineUpdateEventTeam_team\n    }\n    removedAssignedTeams {\n      id\n      ...TodoTimelineUpdateEventTeam_team\n    }\n    __typename\n  }\n  ... on TodoTimelineUpdateEventAssignedRoles {\n    addedAssignedRoles {\n      id\n      ...TodoTimelineUpdateEventRole_role\n    }\n    removedAssignedRoles {\n      id\n      ...TodoTimelineUpdateEventRole_role\n    }\n    __typename\n  }\n}\n\nfragment TodoTimelineUpdateEventCreated_todo on Todo {\n  createdByActor {\n    __typename\n    ...SignedActor_actor\n  }\n  createdAtDate {\n    ...StoreFormattedDate\n  }\n}\n\nfragment TodoTimelineUpdateEventEmployee_employee on Employee {\n  name\n}\n\nfragment TodoTimelineUpdateEventIcon_event on TodoTimelineUpdateEvent {\n  __isTodoTimelineUpdateEvent: __typename\n  __typename\n  ... on TodoTimelineUpdateEventAssignedEmployees {\n    __typename\n  }\n  ... on TodoTimelineUpdateEventTitle {\n    __typename\n  }\n  ... on TodoTimelineUpdateEventBody {\n    __typename\n  }\n  ... on TodoTimelineUpdateEventStatus {\n    newStatus\n    __typename\n  }\n  ... on TodoTimelineUpdateEventPriority {\n    newPriority\n    __typename\n  }\n  ... on TodoTimelineUpdateEventCategory {\n    __typename\n  }\n  ... on TodoTimelineUpdateEventExpireAt {\n    __typename\n  }\n  ... on TodoTimelineUpdateEventTags {\n    __typename\n  }\n  ... on TodoTimelineUpdateEventAssignedTeams {\n    __typename\n  }\n  ... on TodoTimelineUpdateEventAssignedRoles {\n    __typename\n  }\n}\n\nfragment TodoTimelineUpdateEventRole_role on EmployeeRole {\n  name\n}\n\nfragment TodoTimelineUpdateEventTag_tag on TodoCategoryTag {\n  title\n  color\n}\n\nfragment TodoTimelineUpdateEventTeam_team on Team {\n  name\n  color\n  icon\n  ...AHTeamIcon\n}\n\nfragment TodoTimelineUpdateEvent_event on TodoTimelineUpdateEvent {\n  __isTodoTimelineUpdateEvent: __typename\n  __typename\n  ...TodoTimelineUpdateEventIcon_event\n  ...TodoTimelineUpdateEventBody_event\n  ... on TodoTimelineUpdateEventStatus {\n    newStatus\n  }\n}\n\nfragment TodoTimelineUpdateEvent_timelineItem on TodoTimelineUpdate {\n  createdAtDate {\n    ...StoreFormattedDate\n  }\n  createdByActor {\n    __typename\n    ...SignedActorCompact_actor\n    ...SignedActor_actor\n  }\n}\n\nfragment TodoTimelineUpdate_todoTimelineUpdate on TodoTimelineUpdate {\n  events {\n    __typename\n    ...TodoTimelineUpdateEvent_event\n  }\n  ...TodoTimelineUpdateEvent_timelineItem\n}\n\nfragment TodoTimeline_item on TodoTimelineItem {\n  __isTodoTimelineItem: __typename\n  ... on TodoComment {\n    ...TodoTimelineComment_todoComment\n    __typename\n  }\n  ... on TodoTimelineUpdate {\n    __typename\n    ...TodoTimelineUpdate_todoTimelineUpdate\n  }\n  ... on TodoFeedback {\n    __typename\n    ...TodoTimelineFeedback_feedback\n  }\n}\n"
  }
};
})();

(node as any).hash = "468d8aebd8d175084017f6b4a2ac1bef";

export default node;
